/**
 *
 * FreeModeCourse
 *
 */

import { findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Player from '@/components/Player.vue';
import Spinner from '@/components/Spinner.vue';
import Free from '@/components/Book/Free.vue';
import Scheme from '@/components/Book/Scheme.vue';
import PZBroadcast from '@/components/Book/PZBroadcast.vue';
import { FREE_COURSE_ID, BROADCAST_COURSE_ID } from '../../../constants/';

export default {
  name: 'FreeModeCourse',

  components: {
    WayFindBar,
    Footer,
    Aside,
    Player,
    Spinner,
    Free,
    Scheme,
    PZBroadcast,
  },

  data: () => {
    return {
      currentVideo: {},
      isShowPlayer: false,
      FreeCourseId: FREE_COURSE_ID,
      BroadcastCourseId: BROADCAST_COURSE_ID,
    };
  },

  computed: {
    ...mapGetters({
      FilterData: 'FreeModeCourse/FilterData',
      Collection: 'FreeModeCourse/Collection',
      Books: 'FreeModeCourse/Books',
      ReadyToPlayVideos: 'FreeModeCourse/ReadyToPlayVideos',
      isRequest: 'FreeModeCourse/isRequest',
      Course: 'FreeModeCourse/Course',
    }),

    CourseId: function () {
      return this.$route.params.id;
    },
  },

  created() {
    this.$store.dispatch('FreeModeCourse/getFreeCourse', this.CourseId);
  },

  methods: {
    ...mapActions({ addToFavoriteList: 'FreeModeCourse/addToFavoriteList' }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find(v => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
      this.$store.commit('FreeModeCourse/REMOVE_UNFOLLOW_VIDEOS');
    },

    goToNextVideo() {
      const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    changeBook(event) {
      let value = event.target.value;
      this.$store.commit('FreeModeCourse/FILTER_OPTIONAL_COLLECTION_BOOK', value);
    },
  },
};
